import { html } from "lit";
import type { Meta, StoryObj } from "@storybook/web-components";
import { ProactiveCaseClosureProps } from "../src/components/proactive-case-closure/proactive-case-closure";
import { ProactiveCaseClosureModalProps } from "../src/components/proactive-case-closure/proactive-case-closure-modal";
import "../src/app-styles/overrides.css";

const meta = {
    title: "Proactive Case Closure",
    component: "mf-proactive-case-closure",
    argTypes: {
        callId: {
            control: { type: "text" }
        },
        locale: {
            options: ["en_US", "de_DE"],
            control: { type: "select" }
        },
        isApp: {
            control: { type: "boolean" }
        },
        legacyApi: {
            control: { type: "boolean" }
        },
        debug: {
            control: { type: "boolean" }
        }
    },
    render: (args) =>
        html`<div class=${args.isApp ? "mf-service-calls-theme--app" : ""}>
            <mf-proactive-case-closure
                .callId=${args.callId}
                locale="${args.locale}"
                env="qa"
                .debug=${args.debug}
                .isApp=${args.isApp}
                .legacyApi=${args.legacyApi}
            ></mf-proactive-case-closure>
        </div>`
} satisfies Meta<ProactiveCaseClosureProps>;

export default meta;

export const Default: StoryObj<ProactiveCaseClosureProps> = {
    args: {
        callId: "d495e9a6-2f2d-f911-994f-358924b2c06b",
        locale: "en_US",
        isApp: true,
        legacyApi: false
    }
};

export const WithAuth: StoryObj<ProactiveCaseClosureProps> = {
    args: {
        callId: "8a69d948-85dc-4742-9f89-7b1b6a677456",
        locale: "en_US",
        isApp: false,
        legacyApi: false
    }
};

export const Modal: StoryObj<ProactiveCaseClosureModalProps> = {
    args: {
        callId: "d495e9a6-2f2d-f911-994f-358924b2c06b",
        locale: "en_US",
        modalName: "proactive-case-closure",
        legacyApi: false,
        debug: true
    },
    render: (args) =>
        html`<div>
            <button data-trigger-modal=${`open,${args.modalName}`}>Open Modal</button>
            <mf-proactive-case-closure-modal
                call-id="${args.callId}"
                locale="${args.locale}"
                modal-name="${args.modalName}"
                env="qa"
                .isApp=${true}
                .legacyApi=${args.legacyApi}
                .debug=${args.debug}
            ></mf-proactive-case-closure-modal>
        </div>`
};
